'use client';

import Clarity from '@microsoft/clarity';
import { type FC, useEffect } from 'react';

import { requestIdleCallback } from '@/utils/request-idle-callback';

export const ClarityScript: FC = () => {
    useEffect(() => {
        if ('clarity' in window || process.env['NODE_ENV'] === 'development') {
            return;
        }

        const timeout = setInterval(() => {
            if (
                'dataLayer' in window &&
                Array.isArray(window.dataLayer) &&
                window.dataLayer?.some((data) => data?.[0] === 'consent' && data?.[2]?.analytics_storage === 'granted')
            ) {
                clearInterval(timeout);

                requestIdleCallback(() => Clarity.init('skd45b453l'), 3000);
            }
        }, 10000);
    }, []);

    return null;
};
